export interface PersonNameParts {
  first_name?: string | null;
  last_name?: string | null;
  patronymic_name?: string | null;
}

/**
 * Единый порядок отображения ФИО: имя, отчество, фамилия — как в живой речи
 * («Пётр Иванович Иванов»). Канцелярский порядок «Фамилия Имя Отчество» в UI не
 * используется: списки сортируются запросом, а не формой имени.
 * Отсутствующие части пропускаются, при полном отсутствии возвращается пустая строка.
 */
export const formatPersonName = (person: PersonNameParts): string =>
  [person.first_name, person.patronymic_name, person.last_name].filter(Boolean).join(' ');

/** «Петров И. С.»: фамилия и инициалы для подписей и наклеек; без фамилии — только инициалы. */
export const formatShortPersonName = (person: PersonNameParts): string =>
  [person.last_name, ...[person.first_name, person.patronymic_name].map((part) => (part ? `${part.charAt(0)}.` : null))]
    .filter(Boolean)
    .join(' ');
